import { logger } from "c7-logger";

import { client } from "drop-in-ui/api/clients/api-client";

import { Cart, UpdateCartRequest } from "frontend-client";

interface Props {
  cart: Cart;
  currencyCode: string;
  checkoutSessionToken: string;
}

export const updateIntentCart = async ({
  cart,
  currencyCode,
  checkoutSessionToken,
}: Props): Promise<string> => {
  const request = new UpdateCartRequest({
    cart,
    currencyCode,
  });

  try {
    const updateCartResponse = await client.updateCart(request, {
      headers: {
        Authorization: `Bearer ${checkoutSessionToken}`,
      },
    });
    return updateCartResponse.orderDigest;
  } catch (e) {
    logger.error("updateCartResponse error :", e);
    throw e;
  }
};
